/* MYNTIC RACHA 2.0. No framework or network calls. Server owns the count. */
(function(global){
 'use strict';
 const TIERS=['neutral','glow','halo','energy','flame','fire','legendary'];
 const LABELS=['Neutral','Brillo','Halo','Energía','Ignición','Fuego','Legendaria'];
 const instances=new WeakMap(); let serial=0;
 function normalize(value){return typeof value==='number' && Number.isSafeInteger(value) && value>=0 ? value : 0;}
 function index(value){const n=normalize(value);return n>=100?6:n>=50?5:Math.floor(n/10);}
 function getTier(value){return TIERS[index(value)];}
 function create(root,options={}){
  if(!(root instanceof Element))throw new TypeError('Se requiere un elemento del HUD.');
  if(instances.has(root))return instances.get(root);
  if(!global.MynticStreakArtwork)throw new Error('Carga artwork.js antes de streak.js.');
  const original={html:root.innerHTML,cls:root.getAttribute('class'),style:root.getAttribute('style')};
  const adapted=Boolean(options.valueElement);
  root.classList.add('myntic-streak');
  if(adapted)root.classList.add('ms-adapted');
  const value=options.valueElement||document.createElement('b');
  const label=options.labelElement||document.createElement('span');
  if(!adapted){label.textContent='RACHA';root.append(label,value);}
  value.classList.add('ms-value');label.classList.add('ms-label');
  // Keep the accessible number as text, with its expanded equivalent when compacted.
  const accessible=document.createElement('span');accessible.className='ms-sr';root.append(accessible);
  const oldHidden=value.getAttribute('aria-hidden');value.setAttribute('aria-hidden','true');
  const fx=document.createElement('span');fx.className='ms-fx';fx.setAttribute('aria-hidden','true');root.prepend(fx);
  const announcement=document.createElement('span');announcement.className='ms-sr';announcement.setAttribute('role','status');announcement.setAttribute('aria-live','polite');announcement.setAttribute('aria-atomic','true');root.append(announcement);
  const media=matchMedia('(prefers-reduced-motion: reduce)');
  let count=0,tier=-1,motion=options.motion==='reduced'?'reduced':'auto',paused=false,visible=true,destroyed=false;
  let transition=[],oldArt=null,currentArt=null;
  function reduced(){return motion==='reduced'||media.matches;}
  function cancel(){transition.forEach(a=>a.cancel());transition=[];oldArt?.remove();oldArt=null;}
  function sync(){
   root.dataset.msMotion=reduced()?'reduced':'auto';root.dataset.msPaused=String(paused||document.hidden||!visible);
   if(reduced()||paused||document.hidden||!visible)cancel();
  }
  function draw(n){
   const node=document.createElement('span');node.className='ms-art';
   // Trusted, bundled artwork only. Each instance/frame gets its own gradient IDs.
   const id='ms'+(++serial)+'-';node.innerHTML=global.MynticStreakArtwork[n].replaceAll('ms-',id);
   // Restore animation class names; only IDs and URL references are prefixed.
   node.querySelectorAll('[class]').forEach(el=>el.setAttribute('class',el.getAttribute('class').replaceAll(id,'ms-')));
   return node;
  }
  function set(raw,{animate=true,announce=true}={}){
   if(destroyed)return;
   const next=normalize(raw),nt=index(next),previous=tier;
   cancel(); count=next;
   value.textContent=next<10?String(next).padStart(2,'0'):next>999?'999+':String(next);
   value.dataset.msCompact=String(next>999);
   accessible.textContent=String(next)+' aciertos consecutivos. '+LABELS[nt]+'.';
   if(nt===tier)return;
   tier=nt;root.dataset.msTier=TIERS[nt];
   oldArt=currentArt; currentArt=draw(nt);fx.append(currentArt);
   const up=previous>=0&&nt>previous;
   if(animate&&previous>=0&&!reduced()&&!paused&&!document.hidden&&visible&&currentArt.animate){
    const duration=up?(nt===6?720:560):200;
    const timing={duration,easing:'cubic-bezier(.22,.61,.36,1)'};
    transition.push(currentArt.animate([{opacity:0,transform:'translateY(1px)'},{opacity:1,transform:'translateY(0)'}],timing));
    if(oldArt){const retiring=oldArt;const a=retiring.animate([{opacity:1},{opacity:0}],timing);transition.push(a);a.onfinish=()=>{retiring.remove();if(oldArt===retiring)oldArt=null;};}
    if(up)transition.push(value.animate([{transform:'scale(1)'},{transform:'scale(1.02)',offset:.4},{transform:'scale(1)'}],timing));
   }else{oldArt?.remove();oldArt=null;}
   if(up&&announce&&options.announce!==false)announcement.textContent='Racha '+next+'. '+LABELS[nt]+'.';
   else announcement.textContent='';
  }
  const observer=typeof IntersectionObserver==='function'?new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();}):null;
  observer?.observe(root);media.addEventListener('change',sync);document.addEventListener('visibilitychange',sync);
  const api={set,get value(){return count;},get tier(){return TIERS[tier];},setMotion(mode){motion=mode==='reduced'?'reduced':'auto';sync();},pause(on=true){paused=Boolean(on);sync();},destroy(){
   if(destroyed)return;destroyed=true;cancel();observer?.disconnect();media.removeEventListener('change',sync);document.removeEventListener('visibilitychange',sync);
   root.innerHTML=original.html;
   for(const [attr,v] of [['class',original.cls],['style',original.style]]){if(v===null)root.removeAttribute(attr);else root.setAttribute(attr,v);}
   for(const name of ['msTier','msMotion','msPaused'])delete root.dataset[name];instances.delete(root);
  }};
  instances.set(root,api);set(options.initial??0,{animate:false,announce:false});sync();return api;
 }
 global.MynticStreak=Object.freeze({create,getTier,normalize,tiers:TIERS.slice()});
})(window);
